// Reemplazo ligero de @fortawesome/react-fontawesome (docs/RENDIMIENTO.md, Fase 4).
// Genera el mismo SVG que Font Awesome (mismos atributos y clases) a partir de los íconos de
// @fortawesome/free-*-svg-icons, sin cargar el núcleo de Font Awesome (~67 KB de JavaScript).
// Los estilos (.svg-inline--fa, .fa-lg, …) vienen de @fortawesome/fontawesome-svg-core/styles.css,
// importado en src/index.js (antes Font Awesome los inyectaba al cargar la página).

// Como react-fontawesome, el resto de las props (onClick, role, aria-label, style…) pasan al SVG
// y reemplazan a los valores por defecto: p. ej. el botón de cerrar de ModalWhereToBuy tiene el
// onClick en el ícono.
export const FontAwesomeIcon = ({ icon, className = '', ...rest }) => {
    const [width, height, , , pathData] = icon.icon;
    const paths = Array.isArray(pathData) ? pathData : [pathData];
    return (
        <svg
            aria-hidden='true'
            focusable='false'
            data-prefix={icon.prefix}
            data-icon={icon.iconName}
            role='img'
            xmlns='http://www.w3.org/2000/svg'
            viewBox={`0 0 ${width} ${height}`}
            {...rest}
            className={`svg-inline--fa fa-${icon.iconName} ${className}`}
        >
            {paths.map((d, i) => (
                <path key={i} fill='currentColor' d={d} />
            ))}
        </svg>
    );
};

export default FontAwesomeIcon;
